import { LauncherRowTip } from "@mirage/mosaics/Onboarding/DualModeOnboarding/LauncherRowTip";
import { useDualMode } from "@mirage/service-experimentation/useDualMode";
import * as React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type InjectSearchRow<T = any> = {
  component: React.FC<T>;
  position: number;
  props?: T;
};

/**
 * Hook for managing which result rows to inject. Currently there is only one.
 * As more are added, expand the logic here.
 */
export function useInjectedResultRows(): InjectSearchRow | null {
  const { showLauncherSearchTip } = useDualMode();

  if (showLauncherSearchTip) {
    return {
      component: LauncherRowTip,
      position: 3,
      props: {
        marginBottom: "Micro Small",
      },
    };
  }

  return null;
}
